<template>
    <map-filters
        :given-top-level-filter="waterTypeFilter"
        :given-checkbox-groups="checkboxGroups"
        @change="updateFilters"
    />
</template>

<script>
import '@foundryspatial/map-filters/styles.scss';

import MapFilters from '@foundryspatial/map-filters';

import scssVars from '@/assets/scss/_variables.scss';

export default {
    name: 'WatershedMapFilters',

    components: {
        MapFilters,
    },

    computed: {
        waterTypeFilter() {
            return {
                name: 'waterType',
                displayText: 'Water Type',
                selected: ['sw', 'gw'],
                filters: [
                    {
                        name: 'sw',
                        displayText: 'Surface Water',
                        expression: ['==', ['get', 'wat'], 'SW'],
                        color: scssVars.colorAllocationsSw,
                    },
                    {
                        name: 'gw',
                        displayText: 'Groundwater',
                        expression: ['==', ['get', 'wat'], 'GW'],
                        color: scssVars.colorAllocationsGw,
                    },
                ],
            };
        },
        checkboxGroups() {
            return [
                {
                    name: 'term',
                    displayText: 'Type',
                    selected: ['licence', 'stua'],
                    singleColumn: true,
                    filters: [
                        {
                            name: 'licence',
                            displayText: 'Licence',
                            expression: ['==', ['get', 'term'], 'long'],
                        },
                        {
                            name: 'stua',
                            displayText: 'Short Term Use Approval',
                            expression: ['==', ['get', 'term'], 'short'],
                        },
                    ],
                },
                {
                    name: 'purpose',
                    displayText: 'Purpose',
                    selected: [
                        'agriculture',
                        'commercial',
                        'domestic',
                        'municipal',
                        'power',
                        'oil-and-gas',
                        'other',
                    ],
                    filters: [
                        {
                            name: 'agriculture',
                            displayText: 'Agriculture',
                            expression: ['==', ['get', 'purpose_groups'], 'Agriculture'],
                        },
                        {
                            name: 'commercial',
                            displayText: 'Commercial',
                            expression: ['==', ['get', 'purpose_groups'], 'Commercial'],
                        },
                        {
                            name: 'domestic',
                            displayText: 'Domestic',
                            expression: ['==', ['get', 'purpose_groups'], 'Domestic'],
                        },
                        {
                            name: 'municipal',
                            displayText: 'Municipal',
                            expression: ['==', ['get', 'purpose_groups'], 'Municipal'],
                        },
                        {
                            name: 'oil-and-gas',
                            displayText: 'Oil & Gas',
                            expression: ['==', ['get', 'purpose_groups'], 'Oil & Gas'],
                        },
                        {
                            name: 'other',
                            displayText: 'Other',
                            expression: ['==', ['get', 'purpose_groups'], 'Other'],
                        },
                        {
                            name: 'power',
                            displayText: 'Power',
                            expression: ['==', ['get', 'purpose_groups'], 'Power'],
                        },
                    ],
                },
                {
                    name: 'agency',
                    displayText: 'Agency',
                    selected: ['flnrord', 'bcer'],
                    singleColumn: true,
                    filters: [
                        {
                            name: 'flnrord',
                            displayText: 'BC Ministry of Forests',
                            expression: ['==', ['get', 'org'], 'FLNRORD'],
                        },
                        {
                            name: 'bcer',
                            displayText: 'BC Energy Regulator',
                            expression: [
                                'any',
                                ['==', ['get', 'org'], 'NEB'],
                                ['==', ['get', 'org'], 'OGAA'],
                                ['==', ['get', 'org'], 'CER'],
                                ['==', ['get', 'org'], 'GRA'],
                            ],
                        },
                    ],
                },
                {
                    name: 'status',
                    displayText: 'Status',
                    selected: ['application', 'current'],
                    filters: [
                        {
                            name: 'application',
                            displayText: 'Application',
                            expression: ['==', ['get', 'stat'], 'ACTIVE APPL.'],
                        },
                        {
                            name: 'current',
                            displayText: 'Current',
                            expression: ['==', ['get', 'stat'], 'CURRENT'],
                        },
                    ],
                },
            ];
        },
    },

    methods: {
        updateFilters(filterExpressions) {
            this.$emit('change', filterExpressions);
        },
    },
};
</script>

<style lang="scss">
</style>
